import { createContext } from 'react';

export type AccordionContextPayload = {
  onToggleSection: (event: { title: string, index: number, value: boolean }) => void;
  isSectionToggled: (sectionIndex: number) => boolean;
};

export const AccordionContext = createContext<AccordionContextPayload>({
  onToggleSection: () => {},
  isSectionToggled: () => false,
});
